import WebStoragePolyfill from './webstorage-polyfill';

export default class StoreHistory {
  constructor(webstorage = new WebStoragePolyfill()) {
    this._storage = webstorage;
  }

  getLastStoreUrl() {
    let lastStore = JSON.parse(this._storage.getLocalItem('last-store'));

    if (lastStore) {
      let duration = moment.duration(moment().diff(lastStore.time));
      let hours = duration.asHours();
      return hours <= 24 ? lastStore.url : '/marketplace';
    } else {
      return '/marketplace';
    }
  }

  setLastStore(res, clientName, storeName) {
    this._storage.setLocalItem('last-store', JSON.stringify({
      url: `/store/${clientName}/${storeName}`,
      time: moment()
    }));
  }
}



// WEBPACK FOOTER //
// ./source/client/data-providers/store-history.js